import { Flow } from "src/api/flowTypes";
import {
  ANY_FOLDER,
  FlowFolderCapability,
  FlowFolderScope,
} from "src/hooks/useCapabilities/types";

/** Asks about any folder while the flow is unknown, e.g. still loading. */
export const flowFolderScope = (
  flow: Pick<Flow, "flow_folder_id"> | null | undefined,
): FlowFolderScope => (flow ? flow.flow_folder_id : ANY_FOLDER);

/** Withholds an action on one flow until its folder is known. */
export const forFlow = (
  flow: Pick<Flow, "flow_folder_id"> | null | undefined,
  capability: FlowFolderCapability,
): boolean => !!flow && capability(flow.flow_folder_id);
